<template>
  <div id="domain-create-details-tab" @keyup.ctrl.enter="domain_update_data">
    <div class="vx-col w-full">
      <div class="vx-row ">
        <div class="vx-col w-full mb-6 ">
          <vs-input v-model="data_local.domain_id" class="w-full" label-placeholder="Domain ID" readonly/>
        </div>
        <div class="vx-col sm:w-1/2 w-full mb-6 ">
          <vs-input v-model="data_local.domain_name" class="w-full" label-placeholder="Domain Name"/>
        </div>
        <div class="vx-col sm:w-1/2 w-full mb-6 ">
          <vs-select class="w-full mt-5" placeholder="Domain Status" v-model="data_local.domain_status">
            <vs-select-item :key="index" :value="option" :text="option | capitalize" v-for="(option,index) in statusOptions"/>
          </vs-select>
        </div>
      </div>
      <div class="vx-row  mb-6">
        <div class="vx-col w-full">
          <vs-input class="w-full" label-placeholder="Thumbnail URL" v-model="data_local.domain_thumbnail"/>
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full mt-2">
          <vs-textarea v-model="data_local.domain_description" :counter-danger.sync="domain_description_counter" counter="400"
                       height="100px" label="Domain Description"/>
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col w-full">
          <vs-button class="mb-2 mr-2" color="success" type="filled"
                     @click="domain_update_data">Update Domain
          </vs-button>
          <vs-button class="mb-2 ml-2" color="warning" type="border"
                     @click="reset_data">Reset
          </vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data () {
    return {
      data_local: JSON.parse(JSON.stringify(this.data)),
      domain_description_counter: null,

      statusOptions: [
        'active',
        'hidden',
        'disabled'
      ]
    }
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  methods: {
    domain_update_data () {
      this.$emit('update_domainData', this.data_local)
    },
    reset_data () {
      this.data_local = JSON.parse(JSON.stringify(this.data))
    }
  }
}
</script>

<style scoped>

</style>
